export default {
  roleList: {
    results: [],
  },
  moduleList: [],
  moduleListChildren: [],
}